import { Form, FormInstance, Input, Select, TableColumnsType } from 'antd';
import { impactSelectOptions } from '../adjustmentTypes';
import {
  JobAdjustmentParams,
  JobAdjustmentShippingItemViewer,
  JobAdjustmentViewer,
  ShipDateImpactEnum,
} from 'domains/workspaceDomain';
import { clone } from 'lodash-es';
import RevxFlexLayout from 'components/RevxFlexLayout';
import RevxTable from 'components/RevxTable';

type JobAdjustmentShippingProps = {
  canEditStatusByRole: () => boolean;
  data: JobAdjustmentViewer;
  shipAttachmentForm: FormInstance;
  updateJobAdjustmentCostData: (params: JobAdjustmentParams) => void;
  updateJobAdjustmentData: (data: JobAdjustmentViewer) => void;
  runDebounceUpdateJobAdjustmentCostDataHandler: (
    params: JobAdjustmentParams
  ) => void;
  shippingItems?: JobAdjustmentShippingItemViewer[];
  shippingColumns?: TableColumnsType<JobAdjustmentShippingItemViewer>;
};

const JobAdjustmentShipping = ({
  canEditStatusByRole,
  data,
  shippingItems,
  shipAttachmentForm,
  shippingColumns,
  updateJobAdjustmentCostData,
  updateJobAdjustmentData,
  runDebounceUpdateJobAdjustmentCostDataHandler,
}: JobAdjustmentShippingProps) => {
  return (
    <>
      <RevxFlexLayout className="shipping-impact">
        {
          <div className="shipping-impact__select">
            <span style={{ marginRight: 4 }}>Impact to the ship date:</span>
            <Select
              disabled={!canEditStatusByRole()}
              options={impactSelectOptions}
              value={data.shipDateImpact || ShipDateImpactEnum.NONE}
              onChange={async (shipDateImpact) => {
                data.shipDateImpact = shipDateImpact;
                updateJobAdjustmentData(clone(data));
                await updateJobAdjustmentCostData({
                  shipDateImpact,
                });
              }}
            />
          </div>
        }
        {data.shipDateImpact === ShipDateImpactEnum.OTHER && (
          <div className="shipping-impact__reason">
            {canEditStatusByRole() ? (
              <Form form={shipAttachmentForm}>
                <Form.Item
                  name="shipDateImpactAttachment"
                  rules={[{ required: true }]}
                >
                  <Input
                    placeholder="Input reason..."
                    defaultValue={data.shipDateImpactAttachment}
                    onChange={async (e) => {
                      await runDebounceUpdateJobAdjustmentCostDataHandler({
                        shipDateImpact: ShipDateImpactEnum.OTHER,
                        shipDateImpactAttachment: e.target.value,
                      });
                    }}
                  />
                </Form.Item>
              </Form>
            ) : (
              <div>
                Impact to the ship date: {data.shipDateImpactAttachment}
              </div>
            )}
          </div>
        )}
      </RevxFlexLayout>
      <div className={`shipping-table`}>
        <RevxTable<JobAdjustmentShippingItemViewer>
          dataSource={shippingItems}
          columns={shippingColumns}
          pagination={false}
          rowKey="serialNumber"
        />
      </div>
    </>
  );
};

export default JobAdjustmentShipping;
